module.exports = __webpack_public_path__ + "img/mail.0598daa9.svg";